import type { JSX } from 'react';

import { Separator, Text } from '@change/ds-core-ui';
import { LockIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { ShareContainer } from '../shareSunrise';
import { SignatureStatsClosedContainer } from '../stats/signatureStatsSunrise';

export function SideClosedContainer(): JSX.Element {
	return (
		<div className="flex flex-col gap-6">
			<div className="rounded-lg p-1 text-center">
				<Text as="h3" variant="heading" size="small">
					<span className="relative -bottom-0.5 mr-1 inline-block">
						<LockIcon />
					</span>
					<Translate value="fe.pages.petition_show.status.closed" />
				</Text>
			</div>
			<SignatureStatsClosedContainer />
			<Separator orientation="horizontal" className="border-stroke-weak" />
			<h2 className="sr-only">
				<Translate value="fe.components.petition_share.action" />
			</h2>
			<ShareContainer forMobileView={false} />
		</div>
	);
}
